export default {
  canLoadMorePages: state => !!state.links.next,
}
